import { useEffect, useState } from 'react';

const STORAGE_KEY = 'una-bg-animated';

function getInitialEnabled(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  const saved = window.localStorage.getItem(STORAGE_KEY);
  // Default to animated; only an explicit 'false' disables it.
  return saved === null ? true : saved !== 'false';
}

export function useAnimatedBackground() {
  const [isAnimated, setIsAnimated] = useState<boolean>(getInitialEnabled);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, String(isAnimated));
  }, [isAnimated]);

  function toggleAnimated() {
    setIsAnimated((current) => !current);
  }

  return {
    isAnimated,
    toggleAnimated,
  };
}
